import React, { Component } from 'react';
const d3 = window.d3;
import * as d3tip from 'd3-tip';
import Fetch from '../../common/fetch';
import { Auth } from 'aws-amplify';
import './styles.css';


class ScatterPlot extends Component {
    constructor(props) {
        super(props);
        this.fetch = new Fetch();
        this.state = {
            isLoaded: false,
            lineFit: {},
            energyTemp: {}
        }
    }

    // Fetch information from backend databases 
    async componentDidMount() {
        const lineFit = await this.getLineFit();
        const energyTemp = await this.getEnergyTemp();
        // set the values when they are loaded
        this.setState({ isLoaded: true, lineFit, energyTemp });

        // Get the regression line data
        this.lfitdata = lineFit;
        // Get the dots data
        this.data = energyTemp;

        this.renderGraph();
        // resize the plot when window size is changed
        window.addEventListener('resize', this.resize.bind(this));
    }

    // The AWS API Gateway route is /dev/line/fit, this function calls the backend query with assigned 'site' number. 
    // Cognito provides jwtToken
    async getLineFit() {
        const user = await Auth.currentAuthenticatedUser();
        const { jwtToken } = user.signInUserSession.idToken;

        const url = `https://mv9av9jew4.execute-api.us-east-1.amazonaws.com/dev/line/fit?site=${this.props.site}`;
        const options = {
            method: 'GET',
            headers: {
                authorization: jwtToken
            }
        };

        return await this.fetch.request(url, options);
    }

    // The AWS API Gateway route is /dev/energy/temp, this function calls the backend query with assigned 'site' number. 
    async getEnergyTemp() {
        const user = await Auth.currentAuthenticatedUser();
        const { jwtToken } = user.signInUserSession.idToken;

        const url = `https://mv9av9jew4.execute-api.us-east-1.amazonaws.com/dev/energy/temp?site=${this.props.site}`;
        const options = {
            method: 'GET',
            headers: {
                authorization: jwtToken
            }
        };

        return await this.fetch.request(url, options);
    }



    resize() {
        this.settingUp();
        // set plot size
        window.$('.test')
            .attr('width', this.width + this.margin.left + this.margin.right)
            .attr('height', this.height + this.margin.top + this.margin.bottom)

        this.scaleRange();

        this.svg.select('.x.axis').attr('transform', 'translate(0,' + this.height + ')').call(this.xAxis)
        this.svg.select('.y.axis').call(this.yAxis)

        this.defineLine();

        this.svg.select('.line').attr('d', this.valueline(this.lfitdata))

        this.scaleRange();

        // Remove the old scatterplot
        this.svg.selectAll('circle').remove();
        // Add the scatterplot
        this.addScatter();
    } // resize

    // set plot size
    settingUp() {
        const windowWidth = window.innerWidth;
        var setWidth;
        if (windowWidth < 1600) {
            setWidth = window.$(`.${this.props.appendPlot}`).width();
        } else {
            setWidth = window.innerWidth * 0.4;
        }

        this.margin = { top: 20, right: 20, bottom: 30, left: 50 };
        this.width = setWidth - this.margin.left - this.margin.right; // 450
        this.height = 350 - this.margin.top - this.margin.bottom; // 450

        // Set the ranges
        this.x = d3.scaleLinear().range([0, this.width]);
        this.y = d3.scaleLinear().range([this.height, 0]);
        // Define the axes
        this.xAxis = d3.axisBottom(this.x).ticks(5);
        this.yAxis = d3.axisLeft(this.y).ticks(5);
    } // settingUp

    scaleRange() {
        // Scale the range of the data
        this.x.domain(d3.extent(this.data, d => d.temp));
        this.y.domain([0, d3.max(this.data, d => d.energy) + 0.1]);
    }

    defineLine() {
        // Define the line
        this.valueline = d3.line()
            .x(d => this.x(d.temp))
            .y(d => this.y(d.energy))
            .curve(d3.curveMonotoneX); // apply smoothing to the line
    }

    getToolTipValue() {
        // tooltip of temperature and energy values
        const tip = new d3tip.default().html(({ temp, energy }) => `Temperature: ${temp}<br/>Energy: ${energy}`)
            .attr('class', 'tooltip')
            .style('opacity', 0);
        this.svg.call(tip);

        return tip;
    }

    addScatter() {
        // Add the scatterplot and its animation
        const tip = this.getToolTipValue();

        this.svg.selectAll('dot')
            .data(this.data)
            .enter()
            .append('circle')
            .attr('r', 3)
            .attr('cx', d => this.x(d.temp))
            .attr('cy', d => this.y(d.energy))
            .on('mouseover', function (d) {
                tip.style('opacity', 0.9)
                    .show(d, this);
            })
            .on('mouseout', function (d) {
                tip.hide(d, this)
                    .style('opacity', 0);
            })
            .style('opacity', '0.5')
            .transition()
            .ease(d3.easeSin)
            .duration(300)
            .delay(300)
            .style('opacity', '1');
    }

    async renderGraph() {
        this.settingUp();

        // Adds the svg canvas
        this.svg = d3.select(`.${this.props.appendPlot}`).append('svg')
            .attr('class', 'test')
            .attr('width', this.width + this.margin.left + this.margin.right)
            .attr('height', this.height + this.margin.top + this.margin.bottom)
            .append('g')
            .attr('transform', `translate(${this.margin.left}, ${this.margin.top})`);

        this.scaleRange();

        this.addScatter();

        // Add X Y axis
        this.svg.append('g')
            .attr('class', 'x axis')
            .attr('transform', 'translate(0,' + this.height + ')')
            .style('font-size', '14px')
            .call(this.xAxis)
            .append('text')
            .attr('y', 10)
            .attr('dy', '.81em')
            .style('fill', 'black')
            .style('text-anchor', 'middle')
            .text('Temperature');

        this.svg.append('g')
            .attr('class', 'y axis')
            .style('font-size', '14px')
            .call(this.yAxis)
            .append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 6)
            .attr('dy', '.71em')
            .style('fill', 'black')
            .style('text-anchor', 'end')
            .text('Energy');

        this.defineLine();

        // Add the valueline path and its animation.
        this.svg.append('path')
            .datum(this.lfitdata)
            .attr('class', 'line')
            .style('opacity', '0.5')
            .transition()
            .ease(d3.easeSin)
            .duration(300)
            .delay(300)
            .style('opacity', '1')
            .attr('d', this.valueline(this.lfitdata))
            .style('stroke', 'steelblue')
            .style('stroke-width', '2')
            .style('fill', 'none')
            .style('shape-rendering', 'auto');

    } // renderGraph

    render() {
        // if not loaded, show a spinner
        const { isLoaded } = this.state;
        if (!isLoaded) {
            return (
                <div className='d-flex justify-content-center'>
                    <div className='spinner-border text-info' style={{ width: '3rem', height: '3rem' }}></div>
                </div>
            );
        } else {
            return (
                <div>
                    <div className={this.props.appendPlot}></div>
                </div>
            );
        }
    }
}
export default ScatterPlot;


// WEBPACK FOOTER //
// ./src/components/scatter-plot/index.js